import React, { ElementType } from 'react';
import { Plugins } from 'phaser';

import Renderer from './renderer';

import manager from './manager';
import { createRoot } from 'react-dom/client';

type PluginOptions = {
  // the parent element's id to render react dom into
  // if not set will wrap the game canvas with a div and render to that.
  parent: string;
  // if we shouldn't inject our own react dom
  // useful if you already have react
  dontInjectReact: boolean;
};

const defaultOptions: PluginOptions = {
  parent: '',
  dontInjectReact: false,
};

class ReactUI extends Plugins.BasePlugin {
  constructor(pluginManager: Plugins.PluginManager) {
    super(pluginManager);

    //  Register our new Game Object type
    pluginManager.registerGameObject('reactDom', this.createReactDom);
  }

  init(options: PluginOptions) {
    options = { ...defaultOptions, ...options };

    // don't inject react incase the user wants to use this plugin inside a react project.
    if (options.dontInjectReact) return;

    const container = this.game.domContainer;

    if (!container) {
      // eslint-disable-next-line no-console
      return console.error('this plugins requires you have `dom: { createContainer: true }` in your game config');
    }

    createRoot(container).render(<Renderer />);
  }

  createReactDom(component: ElementType<any>, props: object) {
    return manager.addComponent(component, props);
  }
}

export default ReactUI;
